import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

import { devToastMessage } from "../../../_helpers/devToastMessage";

import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { parentEventMegaFormValues } from "../../events-screen/tests/fixtures/parentEventMegaFormValues";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { EventValidationService } from "../../../_services/eventsServices/eventValidation.service";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { UserManagementFormPersonalDetailsComponent } from "../../users/user-management-form-personal-details/user-management-form-personal-details.component";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { NewDiscountFormState } from "../discount-models/NewDiscountFormState";

import { DiscountManagementService } from "../../../_services/discount-management.service";
import { DiscountMethod } from "../discount-models/DiscountMethod";
import { ServerNamespace } from "../../../_models/server/server-namespace";

const devData = {
  event: {
    brotherDiscount: false,
    closedToMembers: false,
    eventEndDate: "",
    eventEndHour: "",
    eventIndex: "",
    eventStartDate: "",
    eventStartHour: "",
    eventType: 0,
    gainCenter1: "",
    gainCenter2: "",
    prices: "",
    registeredChildren: 0,
    registrationEndDate: new Date("2025-03-01T00:00:00.000Z"),
    childEvents: [
      {
        brotherDiscount: false,
        closedToMembers: false,
        eventEndDate: "",
        eventEndHour: "",
        eventIndex: "",
        eventStartDate: "",
        eventStartHour: "",
        eventType: 0,
        gainCenter1: "",
        gainCenter2: "",
        prices: "",
        registeredChildren: 0,
        eventName: "ארוע  שני 123 לסבסוד",
        parentEventId: 188,
        parentEventCode: "121000002",
        childEventCode: "1210996",
        childEventId: 36833,
        childEventPrice: 600,
        circle: [],
        nests: [],
        layers: [],
        childEventPriceChange: [],
        eventCollection: [],
        isSelected: true,
      },
      {
        brotherDiscount: false,
        closedToMembers: false,
        eventEndDate: "",
        eventEndHour: "",
        eventIndex: "",
        eventStartDate: "",
        eventStartHour: "",
        eventType: 0,
        gainCenter1: "",
        gainCenter2: "",
        prices: "",
        registeredChildren: 0,
        eventName: "ארוע  שני 123 לסבסוד",
        parentEventId: 188,
        parentEventCode: "121000002",
        childEventCode: "1210995",
        childEventId: 36834,
        childEventPrice: 500,
        circle: [],
        nests: [],
        layers: [],
        childEventPriceChange: [],
        eventCollection: [],
        isSelected: true,
      },
      {
        brotherDiscount: false,
        closedToMembers: false,
        eventEndDate: "",
        eventEndHour: "",
        eventIndex: "",
        eventStartDate: "",
        eventStartHour: "",
        eventType: 0,
        gainCenter1: "",
        gainCenter2: "",
        prices: "",
        registeredChildren: 0,
        eventName: "ארוע  שני 123 לסבסוד",
        parentEventId: 188,
        parentEventCode: "121000002",
        childEventCode: "1210994",
        childEventId: 36835,
        childEventPrice: 400,
        circle: [],
        nests: [],
        layers: [],
        childEventPriceChange: [],
        eventCollection: [],
        isSelected: true,
      },
      {
        brotherDiscount: false,
        closedToMembers: false,
        eventEndDate: "",
        eventEndHour: "",
        eventIndex: "",
        eventStartDate: "",
        eventStartHour: "",
        eventType: 0,
        gainCenter1: "",
        gainCenter2: "",
        prices: "",
        registeredChildren: 0,
        eventName: "ארוע  שני 123 לסבסוד",
        parentEventId: 188,
        parentEventCode: "121000002",
        childEventCode: "1210993",
        childEventId: 36836,
        childEventPrice: 300,
        circle: [],
        nests: [],
        layers: [],
        childEventPriceChange: [],
        eventCollection: [],
        isSelected: true,
      },
      {
        brotherDiscount: false,
        closedToMembers: false,
        eventEndDate: "",
        eventEndHour: "",
        eventIndex: "",
        eventStartDate: "",
        eventStartHour: "",
        eventType: 0,
        gainCenter1: "",
        gainCenter2: "",
        prices: "",
        registeredChildren: 0,
        eventName: "ארוע  שני 123 לסבסוד",
        parentEventId: 188,
        parentEventCode: "121000002",
        childEventCode: "1210992",
        childEventId: 36837,
        childEventPrice: 1000,
        circle: [],
        nests: [],
        layers: [],
        childEventPriceChange: [],
        eventCollection: [],
        isSelected: true,
      },
    ],
    eventName: "ארוע  שני 123 לסבסוד",
    eventOpenTo: "",
    parentEventCode: "121000002",
    parentEventId: 188,
  },
  children: [
    {
      id: 117917,
      firstName: "  טל",
      lastName: "בר זיו",
      israeliId: "212357***117917",
      address: "",
      nest: "פתח תקווה - כפר גנים ג'",
      layer: 'י"ד',
      parents: "",
      discountEvents: [
        {
          childEventId: "36833",
          hasDiscount: true,
          currentPrice: 600,
          existingDiscount: 10,
        },
        {
          childEventId: "36834",
          hasDiscount: true,
          currentPrice: 500,
          existingDiscount: 10,
        },
        {
          childEventId: "36835",
          hasDiscount: true,
          currentPrice: 400,
          existingDiscount: 100,
        },
        {
          childEventId: "36836",
          hasDiscount: true,
          currentPrice: 300,
          existingDiscount: 100,
        },
        {
          childEventId: "36837",
          hasDiscount: false,
          currentPrice: 1000,
          existingDiscount: 0,
        },
      ],
      childStatus: "HasSomeDiscounts",
    },
  ],
  amount: {
    type: "Number",
    value: 10,
  },
  discountDetails: {
    comments: "",
    numberOfPayments: "1",
    passedCommittee: false,
  },
};

@Component({
  selector: "new-discount-form",
  templateUrl: "./new-discount-form.component.html",
  styleUrls: ["./new-discount-form.component.scss"],
})
export class NewDiscountFormComponent implements OnInit, AfterViewInit {
  @ViewChild("formTabSet") public formTabSet: NgbTabset;
  @Input("modalEventId") public modalUserId: "new" | string;
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();
  public baseFormValue = {
    event: null,
    amount: null,
    children: [],
  };

  public activityFieldsForm: FormGroup = new FormGroup({
    has_extra_unseen_permission: new FormControl(""),
    userFormLayers: new FormControl([]),
    userSelectedOrgans: new FormControl([]),
    availableOrgans: new FormControl([]),
  });
  public userManagementMegaForm: FormGroup = new FormGroup({
    activityFields: this.activityFieldsForm,
  });
  public isNewDiscount: boolean = true;
  public disableSave: boolean = true;
  public specificEventName: string = "ארוע";
  public translations$: Observable<ITranslations>;
  @ViewChild("personalDetailsFormComponent")
  private personalDetailsFormComponent: UserManagementFormPersonalDetailsComponent;
  private _newDiscountFormState$: BehaviorSubject<NewDiscountFormState> =
    new BehaviorSubject<NewDiscountFormState>(this.baseFormValue);

  public newDiscountFormState$: Observable<NewDiscountFormState> =
    this._newDiscountFormState$.asObservable();

  constructor(
    protected translationService: TranslationService,
    protected eventsService: EventsService,
    protected dataService: DataService,
    protected discountManagementService: DiscountManagementService,
    protected authenticationService: AuthenticationService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef,
    protected sessionManagerService: SessionManagerService
  ) {
    this.translations$ = this.translationService.translations;
    this.activityFieldsForm.valueChanges.subscribe((value) => {});
  }

  public ngOnInit(): void {
    this.initPage().then();
    this.userManagementMegaForm.valueChanges.subscribe((value) => {});
  }

  public async devAutoAction() {
    devToastMessage();
    const randNant =
      `${this.specificEventName} ` + Math.floor(Math.random() * 1000);
    const data = parentEventMegaFormValues;
    data.parentEventMain.parentEventDetails.eventName = randNant;
    this.userManagementMegaForm.patchValue(parentEventMegaFormValues);
  }

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  public navigateForm(number: number) {
    const tabNumber = +this.formTabSet.activeId.replace("tab-", "");
    const newTabNumber = tabNumber + number;
    if (number === 1) {
      this.revalidateForm();
    }

    if (newTabNumber < 1 || newTabNumber > 4) {
      return;
    }
    this.formTabSet.select(`tab-${newTabNumber}`);
  }

  public async buildMegaFormObject() {
    const megaFormData = JSON.parse(
      JSON.stringify(this.userManagementMegaForm.value)
    );

    return megaFormData;
  }

  public serializeOneChanichEventFormToPost(): ServerNamespace.PostNewSubsidy[] {
    const newSubsidies: ServerNamespace.PostNewSubsidy[] = [];
    const formValue = this._newDiscountFormState$.getValue();
    const { event, children, amount } = formValue;
    for (const oneHanich of children) {
      for (const oneEvent of oneHanich.discountEvents) {
        if (!oneEvent.hasDiscount) {
          let finalSubsidyAmount = amount.value;

          if (amount.type === DiscountMethod.Percentage) {
            const eventFromParentEventObject = event.childEvents.find(
              (ev) => ev.childEventId.toString() === oneEvent.childEventId
            );

            finalSubsidyAmount =
              this.discountManagementService.calculateDiscountAmountBasedOnPercent(
                eventFromParentEventObject.childEventPrice,
                amount.value
              );
          }
          newSubsidies.push({
            event: Number(oneEvent.childEventId),
            hanich: oneHanich.id,
            final_subsidy_amount: finalSubsidyAmount,
            number_of_payments: formValue.discountDetails.numberOfPayments,
            comments: formValue.discountDetails.comments || "",
            passed_subsidies_committee:
              !!formValue.discountDetails.passedCommittee,
          });
        }
      }
    }

    return newSubsidies;
  }

  public async submit() {
    let saveResponse;
    this.disableSave = true;
    const allNewSubsidies = this.serializeOneChanichEventFormToPost();

    saveResponse = await this.discountManagementService.createNewDiscount(
      allNewSubsidies
    );

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    if (saveResponse.success) {
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "סיום",
        modalText: `  הסבסוד הוזן בהצלחה!`,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        this.closeParentEventModal();
      });
      return;
    } else {
      const isDisconnected =
        saveResponse.error && saveResponse.error.status === 401;

      const errorMessage =
        await EventValidationService.convertServer400ErrorsToReadableText(
          saveResponse.error
        );
      const modalText = isDisconnected
        ? "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש."
        : ` השמירה נכשלה. פרטים:   ${"\n" + errorMessage}`;
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "שגיאה",
        modalText,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        if (isDisconnected) {
          this.closeParentEventModal();
          setTimeout(() => this.router.navigate(["/login"]), 1000);
        }
      });
      this.disableSave = false;
    }
  }

  public async closeParentEventModal() {
    this.modalAction.emit("close");
  }

  public updateDiscountEvent($event: NewDiscountFormState) {
    this._newDiscountFormState$.next($event);

    this.disableSave = this.hasValidationError();
  }

  protected handleError(err: any) {
    const isDisconnected = err.status === 401;
    const noUserPermission = err.status === 400;
    let modalText = err.toString();
    if (noUserPermission) {
      modalText = `אין לך הרשאה מספקת לערוך את ה${this.specificEventName}   `;
    } else if (isDisconnected) {
      modalText = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {
      this.closeParentEventModal().then((r) => r);
      if (isDisconnected) {
        setTimeout(() => this.router.navigate(["/login"]), 1000);
      }
    });
  }

  protected showValidationErrors(validationErrors: string[]) {
    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText: `לשם שמירת ה${this.specificEventName}: ${validationErrors.join(
        ", "
      )}`,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {});
  }

  protected async initPage() {}

  private hasValidationError() {
    const form = this._newDiscountFormState$.getValue();
    const amount = Number(form.amount && form.amount.value) || 0;
    if (!form.discountDetails || !form.discountDetails.numberOfPayments) {
      return true;
    }
    if (!amount || amount < 1 || amount > 100000) {
      return true;
    }
    if (form.amount.type === DiscountMethod.Number) {
      for (const oneHanich of form.children) {
        for (const oneEvent of oneHanich.discountEvents) {
          if (form.amount.value >= oneEvent.currentPrice) {
            return true;
          }
        }
      }
    } else if (
      form.amount.type === DiscountMethod.Percentage &&
      amount >= 100
    ) {
      return true;
    }

    return false;
  }

  private revalidateForm() {
    if (this.personalDetailsFormComponent && this.isNewDiscount) {
      this.personalDetailsFormComponent.revalidateForm();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/new-discount-form/new-discount-form.component.ts